// utils/countdown.js
import { ref, onMounted, onBeforeUnmount } from "vue";

export function useReaminTime(targetTime = "2024-03-20T12:00:00") {
  targetTime = targetTime.replace(/-/g, "/");
  const countdown = ref({
    dd: "00",
    hh: "00",
    mm: "00",
    ss: "00",
    isEnd: true,
  });
  let countdownInterval;

  const startCountdown = () => {
    countdownInterval = setInterval(() => {
      const now = new Date().getTime();
      const target = new Date(targetTime).getTime();

      let timeDiff = target - now;
      if (timeDiff < 0) {
        clearInterval(countdownInterval);
        countdown.value = {
          dd: "00",
          hh: "00",
          mm: "00",
          ss: "00",
          isEnd: true,
        };
      } else {
        const day = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const hour = Math.floor(
          (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minute = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const second = Math.floor((timeDiff % (1000 * 60)) / 1000);

        const formatNumber = (num) => {
          return num < 10 ? "0" + num : String(num);
        };

        countdown.value = {
          dd: formatNumber(day),
          hh: formatNumber(hour),
          mm: formatNumber(minute),
          ss: formatNumber(second),
          isEnd: false,
        };
      }
    }, 1000);
  };

  onMounted(() => {
    startCountdown();
  });

  onBeforeUnmount(() => {
    clearInterval(countdownInterval);
  });

  return countdown;
}
